import React, { Fragment, useEffect } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../styles/balanco.scss'

const Balanco = (props) => {

    const defineArtigo = (fundo) => {
        switch (fundo) {
            case "Consolidado":
                return ""
                break;
            case "Prefeitura Municipal":
                return "da"
                break;
            default:
                return "do"
                break;
        }
    }

    const artigo = defineArtigo(props.balanco.fundo)

    const url = `/transparencia${props.balanco.arquivo}`

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                <Card.Header><h5>Balanço {props.balanco.tipo} {artigo} {props.balanco.fundo} de {props.balanco.ano}</h5></Card.Header>
                    <Card.Body>
                        <a href={url} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Ver Balanço</Button>
                        </a>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Balanco;